<template>
  <div class="main-menu-skeleton">
    <ul v-if="isLoading" class="main-menu-skeleton-list">
      <li class="main-menu-skeleton-list__item" v-for="i in itemsCount" :key="i">
        <div class="main-menu-skeleton-button">
          <div class="main-menu-skeleton-icon skeleton-block"></div>
          <div class="main-menu-skeleton-text skeleton-block"></div>
          <div class="main-menu-skeleton-dropdown skeleton-block"></div>
        </div>
      </li>
    </ul>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    itemsCount: {
      type: Number,
      default: 5
    }
  },
};
</script>

<style lang="scss" scoped>
.main-menu-skeleton {
  &-button {
    display: flex;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #F3F4F6;
  }

  &-icon {
    width: 16px;
    height: 16px;
    margin-right: 16px;
    border-radius: 50%;
  }

  &-text {
    width: 60%;
    height: 14px;
    border-radius: 4px;
  }

  &-dropdown {
    margin-left: auto;
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }

  &-list__item {
    &:nth-child(n+2) {
      margin-top: 8px;
    }
  }
}

.skeleton-block {
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
}
</style>
